import { createConsumer } from '@rails/actioncable'
import { store } from '../store'

// The login JWT goes along as ?token= and is read on every (re)connect, so the server knows who
// is connected. Without a login (e.g. on shared links) the connection stays anonymous.
const cableUrl = () => {
  const base = process.env.REACT_APP_CABLE_URL || ''
  const { jwt } = store.getState().core
  if (!jwt) return base
  return `${base}${base.includes('?') ? '&' : '?'}token=${encodeURIComponent(jwt)}`
}

export const consumer = createConsumer(cableUrl as unknown as string)

// login, logout or a new token: reconnect, so the connection belongs to the right user
let lastJwt = store.getState().core.jwt
store.subscribe(() => {
  const { jwt } = store.getState().core
  if (jwt === lastJwt) return
  lastJwt = jwt
  const { connection } = consumer as unknown as { connection: { reopen: () => void } }
  connection.reopen()
})
